import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Clock, MapPin, X } from 'lucide-react';
import { useRecentSearches } from '@/hooks/useRecentSearches';

interface RecentSearchesProps {
  onSelect: (destination: string, country: string) => void;
}

export function RecentSearches({ onSelect }: RecentSearchesProps) {
  const { recentSearches, clearRecentSearches } = useRecentSearches();

  if (recentSearches.length === 0) {
    return null;
  }

  return (
    <Card className="bg-card/50 backdrop-blur-sm">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Clock className="h-4 w-4 text-muted-foreground" />
            <CardTitle className="text-sm font-medium">Recently Searched</CardTitle>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={clearRecentSearches}
            className="h-7 text-xs"
          >
            <X className="h-3 w-3 mr-1" />
            Clear
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-2">
        {recentSearches.map((search, index) => (
          <Button
            key={index}
            variant="outline"
            className="w-full justify-start h-auto py-3 px-3 sm:py-2 flex-col sm:flex-row items-start sm:items-center gap-2"
            onClick={() => onSelect(search.destination, search.country)}
          >
            <div className="flex items-center gap-2 w-full sm:w-auto sm:flex-1">
              <MapPin className="h-4 w-4 flex-shrink-0" />
              <div className="flex-1 text-left min-w-0">
                <div className="font-medium text-sm">{search.destination}</div>
                <div className="text-xs text-muted-foreground">{search.country}</div>
              </div>
            </div>
            <Badge variant="secondary" className="text-[10px] sm:text-xs px-2 py-0.5 flex-shrink-0 whitespace-nowrap self-end sm:self-auto">
              {new Date(search.timestamp).toLocaleDateString('en-GB', { 
                day: '2-digit',
                month: '2-digit', 
                year: 'numeric'
              })}
            </Badge>
          </Button>
        ))}
      </CardContent>
    </Card>
  );
}
